let en = {
    "translation" : {
    }
};

export default en;
